/**
 * Copyright © Smartex Canada All rights reserved.
 * See LICENSE for license details.
 */

import { initTheme } from "@/components";
import { initProductToolbar } from "@/components/product/list/toolbar";

const init = () => {
    initTheme();
    initProductToolbar();
};

if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
